var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82151 2C4.20455 2 2.87851 3.28148 2.82326 4.8975L2.07112 26.8975C2.01314 28.5935 3.37234 30 5.06937 30H8.93028C10.6273 30 11.9865 28.5935 11.9285 26.8975L11.1764 4.8975C11.1211 3.28148 9.79511 2 8.17815 2H5.82151ZM4.82209 4.96583C4.84051 4.42716 5.28252 4 5.82151 4H8.17815C8.71713 4 9.15915 4.42716 9.17756 4.96583L9.9297 26.9658C9.94903 27.5312 9.49596 28 8.93028 28H5.06937C4.50369 28 4.05063 27.5312 4.06996 26.9658L4.82209 4.96583ZM11.5761 30H26.4998C28.4328 30 29.9998 28.433 29.9998 26.5V7C29.9998 6.59554 29.7562 6.2309 29.3825 6.07612C29.0088 5.92134 28.5787 6.00689 28.2927 6.29289L20.9998 13.5858V7C20.9998 6.59554 20.7562 6.2309 20.3825 6.07612C20.0088 5.92134 19.5787 6.00689 19.2927 6.29289L12.4583 13.1273L12.5518 15.8622L18.9998 9.41421V16C18.9998 16.4045 19.2435 16.7691 19.6171 16.9239C19.9908 17.0787 20.4209 16.9931 20.7069 16.7071L27.9998 9.41421V26.5C27.9998 27.3284 27.3282 28 26.4998 28H25.9998V20.5C25.9998 19.6716 25.3282 19 24.4998 19H16.4998C15.6714 19 14.9998 19.6716 14.9998 20.5V28H12.8045C12.6023 28.7849 12.1672 29.4782 11.5761 30ZM16.9998 28V21H23.9998V28H16.9998Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturing);
export default __webpack_public_path__ + "static/media/Manufacturing.ec3cd66a8407d66d747d1bb99d35e586.svg";
export { ForwardRef as ReactComponent };